<template>
  <div>
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            @click.stop="$router.push('/return-orders/' + order.account_id + '/' + order.id)"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("ReturnOrder.ObjectName")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="showEdit"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              detailMode
                ? $emit('edit')
                : $router.push('/return-orders/' + order.account_id + '/' + order.id + '/edit')"
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("CRUD.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.editInfo", [$t("ReturnOrder.ObjectName")]) }}</span>
      </v-tooltip>
    </v-sheet>
  </div>
</template>

<script>

export default {
  name: "OrderActions",

  components: {
  },

  props: {
    order: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
  },

  computed: {},

  data: () => ({
    printBtnMenu: false,
    cancelAlert: false,
  }),

  methods: {
  },
};
</script>